import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  activeConIdSet,
  branchNameSet,
  dealershipNameSet,
  getActiveConId,
  getOpenCreateLead,
  openCreateLeadToggled,
} from "../redux/userSlice";
import ResetPassword from "../sections/auth/reset-password";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import MenuIcon from "@mui/icons-material/Menu";
import { getMode, modeSet } from "../redux/layoutSlice";

import {
  authSet,
  branchUidSet,
  buyAgentSet,
  getIsBuyAgent,
  getOriginUid,
  getStaffUid,
  getUid,
  logout,
} from "../redux/authSlice";
import { getData } from "../utils/firebase";
import CreateLead from "../sections/dashboard/create-lead";

import NavMenu from "../components/nav-menu";
import Feedback from "../sections/dashboard/feedback";
import { child, get } from "firebase/database";
import { dbRef } from "../firebase/app";
import Dialog from "../components/dialog/dialog";
import { logoutUser } from "../utils/logout";
import { useResponsive } from "../hooks/use-media-query";
import Messenger from "../assets/icon/messenger";
import AppointmentIcon from "../assets/icon/appointment-icon";
import ReportIcon from "../assets/icon/report";
// import AnimationButton from "../components/button/animation-button";
import { Button } from "../components";
import InventoryIcon from "../assets/icon/inventory";
import Menu from "../components/menu/menu";
import CampaignIcon from "../assets/icon/campaign";

interface Branch {
  dealerName: string;
  dealerUid: string;
  product: string;
}

export function ContactUs({ open }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dealerUid = useSelector(getUid) as string | null;
  const staffUid = useSelector(getStaffUid) as string | null;
  const originUid = useSelector(getOriginUid) as string | null;

  const handleLogout = async () => {
    // dealerUid is the branch/dealer, userUid is the actual user (staff or manager)
    const userUid = staffUid || originUid;

    try {
      // Set offline and sign out (offline is set first inside logoutUser)
      await logoutUser(dealerUid, userUid);

      // Clean up local state
      dispatch(authSet(undefined));
      dispatch(logout());
      localStorage.removeItem("branchUid");
      navigate("login");
    } catch (error) {
      console.log(error);
    }
  };

  const renderTitle = "Contact support";

  const renderContent = (
    <Typography align="center">
      Your account has been suspended, please contact support.
      <br /> (888) 288-8856.
    </Typography>
  );

  return (
    <Dialog
      open={open}
      handleClose={handleLogout}
      fullWidth
      renderContent={renderContent}
      renderTitle={renderTitle}
    />
  );
}

const Navbar = () => {
  // State
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [branchAnchorEl, setBranchAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openResetPassword, setOpenResetPassword] = React.useState(false);
  const [openFeedBackDialog, setOpenFeedBackDialog] = React.useState(false);
  const openCreateLead = useSelector(getOpenCreateLead);
  const [isActive, setIsActive] = React.useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mode = useSelector(getMode);
  const uid = useSelector(getUid);
  const isBuyAgent = useSelector(getIsBuyAgent);
  // const dealerName = useSelector(getDealerName);
  const { isCustomLayout, isMobile, isSmall } = useResponsive();
  const activeConId = useSelector(getActiveConId);
  const [branches, setBranches] = React.useState<Branch[]>([]);

  React.useEffect(() => {
    const handleGetItem = () => {
      const path = `/dealers/${uid}/info/dealerName`;
      getData(path)
        .then((r) => dispatch(dealershipNameSet(r)))
        .catch((r) => console.log(`error getting ${path}`, r));
    };

    handleGetItem();
  }, [dispatch, uid]);

  // const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) =>
  //   setAnchorEl(event.currentTarget);

  const handleCloseMenu = () => {
    setBranchAnchorEl(null);
    setAnchorEl(null);
  };

  const handleCloseBranchMenu = () => {
    setBranchAnchorEl(null);
    handleCloseMenu();
  };

  const handleOpenBranchMenu = (event: React.MouseEvent<HTMLElement>) => {
    setBranchAnchorEl(event.currentTarget);
  };

  const handleResetPassword = () => {
    setAnchorEl(null);
    setOpenResetPassword(!openResetPassword);
  };

  // const toggleDrawer = () => {
  //   setOpen();
  // };

  const handleFeedback = () => {
    setOpenFeedBackDialog(!openFeedBackDialog);
  };

  const getModeStatus = React.useCallback(() => {
    //TODO: get color mode from local storage
    const colorMode = localStorage.getItem("colorMode");
    if (colorMode) {
      dispatch(modeSet(colorMode));
    }
    // getData(`dealers/${uid}/info/dashboardSettings/theme`).then((r) => dispatch(modeSet(r)));
  }, [dispatch]);

  React.useEffect(() => {
    getModeStatus();
  }, [getModeStatus]);

  React.useEffect(() => {
    get(child(dbRef, `/dealers/${uid}/info/isActive`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setIsActive(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [uid]);

  const { pathname } = useLocation();
  const appointment = pathname === "/appointment";
  const report = pathname === "/report";
  const campaign = pathname.startsWith("/campaign");
  const setting = pathname.includes("/setting");
  const cars = pathname === "/cars";
  const trainingRequest = pathname === "/training-request";
  const inbox = !cars && !setting && !report && !appointment && !campaign && !trainingRequest;

  React.useEffect(() => {
    return () => {
      // setBranches([]);
      // console.log("clearing branches names");
    };
  }, []);

  const renderRoutes = (
    <Box width={"100%"} margin={"auto"} borderRadius={3} gap={1} display={"flex"} p={1}>
      <Button
        variant="text"
        sx={{
          display: "flex",
          bgcolor: (theme: any) => inbox && theme.palette.primary[100],
          color: (theme: any) => (inbox ? theme.palette.primary.main : "#A6A6A6"),
          px: 2,
          fontWeight: "bold",
          fontSize: "1rem",
          borderRadius: 2,
          "&:hover": { bgcolor: (theme: any) => inbox && theme.palette.primary[100] },
        }}
        startIcon={<Messenger />}
        onClick={() => {
          navigate("/");
          dispatch(activeConIdSet(undefined));
        }}
      >
        Inbox
      </Button>
      <Button
        variant="text"
        sx={{
          display: "flex",
          bgcolor: (theme: any) => appointment && theme.palette.primary[100],
          // color: "#A6A6A6",
          color: (theme: any) => (appointment ? theme.palette.primary.main : "#A6A6A6"),
          px: 2,
          fontWeight: "bold",
          fontSize: "1rem",
          borderRadius: 2,
          "&:hover": { bgcolor: (theme: any) => appointment && theme.palette.primary[100] },
        }}
        startIcon={<AppointmentIcon />}
        onClick={() => navigate("/appointment")}
      >
        Appointment
      </Button>
      {!isBuyAgent && (
        <Button
          variant="text"
          sx={{
            display: "flex",
            bgcolor: (theme: any) => report && theme.palette.primary[100],
            color: (theme: any) => (report ? theme.palette.primary.main : "#A6A6A6"),
            px: 2,
            fontWeight: "bold",
            fontSize: "1rem",
            borderRadius: 2,
            "&:hover": { bgcolor: (theme: any) => report && theme.palette.primary[100] },
          }}
          startIcon={<ReportIcon />}
          onClick={() => navigate("/report")}
        >
          Report
        </Button>
      )}

      {!isSmall && !isBuyAgent && (
        <Button
          variant="text"
          sx={{
            display: "flex",
            bgcolor: (theme: any) => campaign && theme.palette.primary[100],
            color: (theme: any) => (campaign ? theme.palette.primary.main : "#A6A6A6"),
            px: 2,
            fontWeight: "bold",
            fontSize: "1rem",
            borderRadius: 2,
            "&:hover": { bgcolor: (theme: any) => campaign && theme.palette.primary[100] },
          }}
          startIcon={<CampaignIcon fill={campaign ? "#07A4FC" : "#A6A6A6"} />}
          onClick={() => navigate("/campaign")}
        >
          Campaign
        </Button>
      )}

      {!isBuyAgent && (
        // <AnimationButton
        //   startIcon={<InventoryIcon />}
        //   onClick={() => navigate("/cars")}
        //   title="Inventory"
        // />
        <Button
          variant="outlined"
          startIcon={<InventoryIcon sx={{ fill: "#07A4FC" }} />}
          onClick={() => navigate("/cars")}
          sx={{ borderRadius: "16px", fontSize: "16px", height: "48px", padding: "10px 16px" }}
        >
          Cartelligent
        </Button>
      )}
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          display: isMobile && activeConId ? "none" : "block",
          top: "45px",
          left: 0,
          right: 0,
          // px: { xs: 0, sm: 4 },
          boxShadow: "none",
          // bgcolor: (theme) => theme.bg.paper,
          backgroundImage: "none",
          height: 70,
          // borderRadius: 4,
          backgroundColor: "inherit",
          paddingLeft: isCustomLayout ? "0" : "90px !important",
          // marginTop: "12px",
          zIndex: "200",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            justifyContent: isCustomLayout ? "center" : "space-evenly",
            height: "100%",
            bgcolor: (theme) => theme.bg.paper,
            borderRadius: "16px",
            paddingX: "24px",
            paddingLeft: isSmall ? "54px" : "24px",
          }}
        >
          {/* {!isCustomLayout && (
            <IconButton
              edge="start"
              color="primary"
              aria-label="open drawer"
              sx={{
                marginLeft: { lg: -2, xs: 0 },
                marginRight: { lg: 1, xs: 0 },
                borderRadius: 1,
                bgcolor: (theme) => theme.palette.secondary.main,
              }}
              onClick={toggleDrawer}
            >
              <MenuIcon />
            </IconButton>
          )} */}

          <Link onClick={() => dispatch(activeConIdSet(undefined))} to="/">
            <img
              width={77}
              src={`/images/${mode === "dark" ? "DriveeLOGOLightVersion.webp" : "drivee-logo.svg"}`}
              alt="logo Drivee"
              style={{ cursor: "pointer", display: "flex" }}
              loading="lazy"
            />
          </Link>
          {!isCustomLayout && renderRoutes}

          <Box flex={1} />
          <Box
            gap={1}
            sx={{
              flexGrow: 0,
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* {!isBuyAgent && !isCustomLayout && (
              <OutlineAnimationButton title="AI Voice coming soon" onClick={handleVoice} />
            )} */}
            {/* <Box
              bgcolor={mode === "dark" ? "#313645" : "#F8F8F8"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
              p={0.5}
              borderRadius={"16px"}
              padding="5px 10px"
            >
              {dealerName !== "" && (
                <Box display={"flex"}>
                  <Box width={"100%"} display={"flex"} alignItems={"end"} flexDirection={"column"}>
                    <Typography
                      noWrap
                      variant="body2"
                      color={(theme) => theme.palette.text.primary}
                      fontWeight={700}
                    >
                      {branches && branchName ? branchName : dealerName}
                    </Typography>
                  </Box>
                </Box>
              )}
              {
                <Fab
                  onClick={handleOpenUserMenu}
                  icon={<PersonIcon />}
                  sx={{
                    backgroundColor: mode === "dark" ? "#232323" : "#E4E4E4",
                    boxShadow: "none",
                    color: isCustomLayout && mode === "dark" ? "#fff" : "#000",
                    "&:hover": {
                      backgroundColor: mode === "dark" ? "#232323" : "#E4E4E4",
                    },
                  }}
                />
              }
            </Box> */}
          </Box>
        </Toolbar>
        <NavMenu
          anchorEl={anchorEl}
          handleClose={handleCloseMenu}
          handleCloseBranchMenu={handleCloseBranchMenu}
          handleOpenBranchMenu={handleOpenBranchMenu}
          branches={branches}
          setBranches={setBranches}
        />
        <Menu
          anchorEl={branchAnchorEl}
          handleClose={handleCloseBranchMenu}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          items={branches.map((branch) => ({
            label: (
              <Box
                key={branch.dealerUid}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "16px",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Typography fontWeight={500} sx={{ fontSize: "16px" }}>
                  {branch.dealerName}
                </Typography>
                {branches.find((item) => item.product === "buy agent") &&
                  branches.find((item) => item.product === "sales agent") && (
                    <Box
                      sx={{
                        fontSize: "12px",
                        borderRadius: "50px",
                        padding: "0 8px",
                        backgroundColor: branch.product === "sales agent" ? "#2B7FFF" : "#279f23",
                        color: "white",
                        fontWeight: 400,
                        textTransform: "capitalize",
                      }}
                    >
                      {branch?.product}
                    </Box>
                  )}
              </Box>
            ),
            onClick: () => {
              navigate("/");
              dispatch(branchUidSet(branch.dealerUid));
              dispatch(branchNameSet(branch.dealerName));
              localStorage.setItem("branchUid", branch.dealerUid);
              localStorage.setItem("branchName", branch.dealerName);
              dispatch(activeConIdSet(null));
              handleCloseBranchMenu();
              const buyagentStatus = branch.product === "sales agent" ? false : true;
              dispatch(buyAgentSet(buyagentStatus));
            },
            sxText: { color: branch.dealerUid === uid ? "#0290ff !important" : "" },
          }))}
        />
        <ResetPassword open={openResetPassword} handleClose={handleResetPassword} />
        <CreateLead open={openCreateLead} handleClose={() => dispatch(openCreateLeadToggled())} />
        <Feedback open={openFeedBackDialog} handleClose={handleFeedback} />
        <ContactUs open={!isActive} />
      </AppBar>
    </>
  );
};

export default Navbar;
